import React, { useState, useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Translate, translate } from 'react-jhipster';
import { Form, Input, Button, Row, Col, Breadcrumb, Select, Tag } from 'antd';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import {
  getSurveillant,
  updateSurveillant,
  createSurveillant,
  reset,
  createSurveillantGeneral,
  createControleurBus,
} from './surveillant.reducer';
import { getEcole } from '../ecole/ecole.reducer';
import { AUTHORITIES } from 'app/config/constants';
import { hasAnyAuthority } from 'app/shared/auth/private-route';

const { Option } = Select;

export const SurveillantUpdate = ({ match, history }: RouteComponentProps<{ id: string; ecoleid: string }>) => {
  const dispatch = useAppDispatch();
  const isNew = !match.params || !match.params.id;

  const surveillant = useAppSelector(state => state.surveillant.entity);
  const surveillantGeneral = useAppSelector(state => state.surveillant.entitySG);
  const updateSuccess = useAppSelector(state => state.surveillant.updateSuccess);
  const updating = useAppSelector(state => state.surveillant.updating);
  const currentEcole = useAppSelector(state => state.ecole.entity);
  const isNotSurveillantGeneral = !useAppSelector(state =>
    hasAnyAuthority(state.authentication.account.authorities, [AUTHORITIES.SURVEILLANT_GENERAL])
  );

  const [showPassword, setShowPassword] = useState(true);

  useEffect(() => {
    dispatch(getEcole(match.params.ecoleid));
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getSurveillant(match.params.id));
    }
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      history.push(`/surveillant/${currentEcole?.id}`);
    }
  }, [updateSuccess]);

  const handleRoleChange = (role: string) => {
    setShowPassword(role !== AUTHORITIES.SURVEILLANT_GENERAL);
  };

  const saveSurveillantOrControleur = values => {
    const { role } = values;

    const entity = {
      ...(role === AUTHORITIES.SURVEILLANT_GENERAL ? surveillantGeneral : surveillant),
      ...values,
      ecoleId: match.params.ecoleid,
    };

    if (isNew) {
      if (role === AUTHORITIES.SURVEILLANT_GENERAL) {
        dispatch(createSurveillantGeneral(entity));
      } else if (role === AUTHORITIES.CONTROLEUR) {
        dispatch(createControleurBus(entity));
      } else {
        dispatch(createSurveillant(entity));
      }
    } else {
      dispatch(updateSurveillant(entity));
    }
  };

  const renderBreadcrumb = () => (
    <Breadcrumb className="p-2">
      <Breadcrumb.Item>
        <Link to={`/home/${currentEcole?.id}`}>{currentEcole?.nom}</Link>
      </Breadcrumb.Item>
      <Breadcrumb.Item>
        <Link to={`/surveillant/${currentEcole?.id}`}>Surveillants</Link>
      </Breadcrumb.Item>
      {!isNew && (
        <Breadcrumb.Item>
          <Link to={match.url}>Details</Link>
        </Breadcrumb.Item>
      )}
    </Breadcrumb>
  );

  const renderTitle = () => (
    <h2 id="korischoolApp.surveillant.home.createOrEditLabel" data-cy={isNew ? 'SurveillantrCreateHeading' : 'SurveillantUpdateHeading'}>
      <Translate contentKey={`korischoolApp.surveillant.home.${isNew ? 'createLabel' : 'editLabel'}`} />
    </h2>
  );

  return (
    <div>
      {renderBreadcrumb()}
      <Row className="justify-content-center">
        <Col span={12}>{renderTitle()}</Col>
      </Row>
      <Row className="justify-content-center">
        <Col span={18} offset={6}>
          <Form
            labelCol={{ span: 6 }}
            wrapperCol={{ span: 18 }}
            layout="vertical"
            size="large"
            onFinish={saveSurveillantOrControleur}
            initialValues={!isNew ? surveillant : {}}
          >
            <Form.Item label="Login" name="login" rules={[{ required: true }]}>
              <Input placeholder="login" />
            </Form.Item>
            <Form.Item label="Matricule" name="matricule" rules={[{ required: true }]}>
              <Input placeholder="matricule" />
            </Form.Item>
            <Form.Item label="Prénom" name="firstName" rules={[{ required: true }]}>
              <Input placeholder="Prenom" />
            </Form.Item>
            <Form.Item label="Nom" name="lastName" rules={[{ required: true }]}>
              <Input placeholder="Nom" />
            </Form.Item>
            <Form.Item
              label="Téléphone"
              name="telephone"
              rules={[
                { required: true, message: 'Ce champ est requis' },
                {
                  pattern: /^\d{9}$/,
                  message: 'Ce champ doit contenir exactement 9 chiffres',
                },
              ]}
            >
              <Input
                placeholder="Téléphone"
                maxLength={9}
                inputMode="numeric"
                onKeyPress={e => {
                  if (!/[0-9]/.test(e.key)) {
                    e.preventDefault();
                  }
                }}
              />
            </Form.Item>
            <Form.Item label="E-mail" name="email" rules={[{ required: true, type: 'email', message: 'Saisir un e-mail valide' }]}>
              <Input placeholder="E-mail" />
            </Form.Item>
            <Form.Item label="Adresse" name="adresse" rules={[{ required: true }]}>
              <Input.TextArea placeholder="Adresse" />
            </Form.Item>

            {isNew && isNotSurveillantGeneral && (
              <Form.Item label="Role" name="role" initialValue={AUTHORITIES.SURVEILLANT}>
                <Select placeholder="Role" onChange={handleRoleChange}>
                  <Option value={AUTHORITIES.SURVEILLANT}>
                    <Tag color="gray">Surveillant</Tag>
                  </Option>
                  <Option value={AUTHORITIES.SURVEILLANT_GENERAL}>
                    <Tag color="gray">Surveillant Général</Tag>
                  </Option>
                  <Option value={AUTHORITIES.CONTROLEUR}>
                    <Tag color="gray">Contrôleur Bus</Tag>
                  </Option>
                </Select>
              </Form.Item>
            )}

            {isNew && showPassword && (
              <>
                <Form.Item label="Mot de passe" name="password">
                  <Input.Password placeholder="Mot de passe" />
                </Form.Item>
                <Form.Item
                  label="Confirmez mot de passe"
                  name="confirmPassword"
                  dependencies={['password']}
                  rules={[
                    { required: true, message: 'SVP confirmez votre mot de passe!' },
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (!value || getFieldValue('password') === value) {
                          return Promise.resolve();
                        }
                        return Promise.reject(new Error('Mot de passe non identique'));
                      },
                    }),
                  ]}
                >
                  <Input.Password placeholder="Confirmez mot de passe" />
                </Form.Item>
              </>
            )}

            <Form.Item>
              <Button style={{ backgroundColor: '#F28E19', color: 'white' }} htmlType="submit" loading={updating} id="save-entity">
                Enregistrer
              </Button>
            </Form.Item>
          </Form>
        </Col>
      </Row>
    </div>
  );
};

export default SurveillantUpdate;
